import React from "react";
import ReactDOM from "react-dom/client";
import "./style/index.less";

import App from "./pages/app";
import "./config";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
